import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { blogService } from '../services/api';

export default function BlogPostsPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPosts();
  }, []);

  const loadPosts = async () => {
    try {
      const data = await blogService.getAll();
      setPosts(data);
    } catch (error) {
      console.error('Error loading posts:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this post?')) {
      return;
    }
    try {
      await blogService.delete(id);
      setPosts(posts.filter(p => p.id !== id));
    } catch (error) {
      console.error('Error deleting post:', error);
      alert('Error deleting post');
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      published: 'badge-success',
      draft: 'badge-warning',
      archived: 'badge-gray',
    };
    return badges[status] || 'badge-gray';
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent"></div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Blog Posts | CR Hood Admin</title>
      </Helmet>

      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-gray-900">Blog Posts</h1>
          <Link to="/blog/new" className="btn btn-primary">New Post</Link>
        </div>

        <div className="card p-0 overflow-hidden">
          {posts.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-gray-500">No blog posts yet</p>
              <Link to="/blog/new" className="text-accent hover:underline text-sm mt-1 inline-block">
                Create your first post
              </Link>
            </div>
          ) : (
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Status</th>
                    <th>Created</th>
                    <th>Published</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {posts.map((post) => (
                    <tr key={post.id}>
                      <td>
                        <div>
                          <p className="font-medium">{post.title}</p>
                          <p className="text-xs text-gray-500">/blog/{post.slug}</p>
                        </div>
                      </td>
                      <td>
                        <span className={`badge ${getStatusBadge(post.status)}`}>
                          {post.status}
                        </span>
                      </td>
                      <td>{new Date(post.createdAt).toLocaleDateString()}</td>
                      <td>{post.publishedAt ? new Date(post.publishedAt).toLocaleDateString() : '-'}</td>
                      <td>
                        <div className="flex items-center gap-2">
                          {post.status === 'published' && (
                            <a
                              href={`http://localhost:3000/blog/${post.slug}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-gray-400 hover:text-gray-600"
                              title="View"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                              </svg>
                            </a>
                          )}
                          <Link
                            to={`/blog/${post.id}`}
                            className="text-accent hover:underline text-sm"
                          >
                            Edit
                          </Link>
                          <button
                            onClick={() => handleDelete(post.id)}
                            className="text-red-500 hover:underline text-sm"
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
